import enUS from "./en-US.json";

const locales = {
  "en-US": enUS,
};

export default locales;
